export const messages = {
  exploreByStage: "Explore by Stage",
  talkToUs: "Talk to us",
  getInTouch: "Get in touch",
};
